import { render, staticRenderFns } from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=template&id=db81e4ac&scoped=true"
import script from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=script&lang=ts"
export * from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=script&lang=ts"
import style0 from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=style&index=0&id=db81e4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db81e4ac",
  null
  
)

/* custom blocks */
import block0 from "./ActivityDraggableTextButtonsForHotspots.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports